import { Chip, ChipProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { teceoGrayBackground, teceoGrayFont } from '../../../Theme';
import useTeceoStyles from '../../../useTeceoStyles';

const useStyles = makeStyles()(() => ({
  chip: {
    backgroundColor: teceoGrayBackground,
    color: teceoGrayFont,
  },
}));

type OrderChipProps = {
  name: string;
  showTooltip?: boolean;
} & ChipProps;

const OrderChip = ({ name, showTooltip = false, ...rest }: OrderChipProps) => {
  const { classes, cx } = useStyles();
  const { classes: teceoClasses } = useTeceoStyles();

  return (
    <Chip
      title={name}
      component="span"
      label={name}
      size="small"
      {...rest}
      className={cx(teceoClasses.tag, classes.chip, rest.className)}
    />
  );
};

export default OrderChip;
